<style scoped lang="less" rel="stylesheet/less">
	.bandedAnimate {
		width: 100%;
		height: 100%;
		position: absolute;
		z-index: 999999991;
		left: 0;
		top: 0;
		overflow: hidden;
		.circle {
			width: 315px;
			height: 315px;
			border-radius: 50%;
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
			border:300vh solid #262625;
			box-sizing: content-box;
			animation: banned_animate1 1s cubic-bezier(0.645, 0.045, 0.355, 1.000);
			opacity:0;
		}
		.shadow{
			width: 315px;
			height: 315px;
			position: absolute;
			left: 50%;
			top: 50%;
			margin-left: -157px;
			margin-top: -157px;
			border-radius: 50%;
			animation: banned_animate2 1.5s .55s;
			opacity: 0;
			img{
				width: 312px;
				height: 315px;
				transition-duration: .5s;
				border-radius: 50%;
			}
			// p{
			// 	color: white;
			// 	position: absolute;
			// 	bottom: -50px;
			// 	z-index: 10;
			// 	font-size: 18px;
			// 	width: 120%;
			// };
		}
	}
</style>
<template>
	<div class="bandedAnimate">
		<div class="circle">
		</div>
		<div class="shadow">
			<img :src="imgsrc" alt="">
			<!-- <p>老师已经禁言，你不能发言了</p> -->
		</div>
	</div>
</template>

<script>
export default {
	data(){
		return{
			imgsrc:''
		}
	},
	created(){
		setTimeout(()=>{
			this.imgsrc = '/static/img/video/notice.gif?time='+Date.now()
		},500)
	}
}
</script>


// WEBPACK FOOTER //
// src/components/bussiness/video/bandedAnimate.vue